import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Paper,
  Typography,
  Button,
  Modal,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import axios from "axios";
import { localeTextVietnamese } from "../../utils/localeText-vn";
import { generateSlug } from "../../utils/CurrencyFormat";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { formatDate } from "../../utils/CurrencyFormat";

export default function CouponPage() {
  const [rows, setRows] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [images, setImages] = React.useState([]);
  const [formData, setFormData] = React.useState({
    code: "",
    price: 0,
    startDate: "",
    endDate: "",
  });
  const [errors, setErrors] = React.useState({});
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });
  const [totalItems, setTotalItems] = React.useState(0);

  // setting collumn
  const columns = [
    { field: "index", headerName: "STT", width: 100 },
    { field: "code", headerName: "Mã giảm giá", flex: 3 },
    { field: "price", headerName: "Giá tiền", flex: 3 },
    {
      field: "startDate",
      headerName: "Ngày bắt đầu",
      flex: 3,
      renderCell: (params) => {
        return <span>{formatDate(params.value)}</span>;
      },
    },
    {
      field: "endDate",
      headerName: "Ngày kết thúc",
      flex: 3,
      renderCell: (params) => {
        return <span>{formatDate(params.value)}</span>;
      },
    },
    {
      field: "action",
      headerName: "Thao tác",
      description: "",
      sortable: false,
      flex: 3,
      renderCell: (params) => (
        <Box
          sx={{ display: "flex", gap: 1, alignItems: "center", height: "100%" }}
        >
          <Button
            variant="contained"
            color="warning"
            onClick={(event) => {
              event.stopPropagation();
              handleEdit(params.row);
            }}
          >
            Chỉnh sửa
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              handleDelete(params.id);
            }}
          >
            Xoá
          </Button>
        </Box>
      ),
    },
  ];

  const handleEdit = (row) => {
    handleOpen(row);
  };

  React.useEffect(() => {
    getData();
  }, [paginationModel]);

  const getData = () => {
    axios
      .get(`/api/v1/coupons`, {
        params: {
          page: paginationModel.page,
          limit: paginationModel.pageSize,
          paginationAdmin: true,
        },
      })
      .then((res) => {
        setRows(res.data.coupons);
        setTotalItems(res.data.totalItems);
      })
      .catch((err) => console.log(err));
  };

  const rowsWithIndex = rows.map((row, index) => ({
    index: index + 1,
    ...row,
    parentId: row.parentId == 0 ? "" : row.parentId,
  }));

  const handleOpen = (data) => {
    setOpen(true);
    if (data) {
      setFormData({
        ...data,
        startDate: data.startDate
          ? new Date(data.startDate).toISOString().split("T")[0]
          : "",
        endDate: data.endDate
          ? new Date(data.endDate).toISOString().split("T")[0]
          : "",
      });
    }
  };

  const handleClose = (isReload) => {
    setOpen(!open);
    setFormData({});
    setErrors({});
    if (isReload) {
      getData();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        code: formData.code,
        price: formData.price,
        startDate: formData.startDate,
        endDate: formData.endDate,
      };
      axios
        .post(`/api/v1/coupons`, sendData)
        .then((res) => {
          toast("Thêm mã giảm giá thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast(err.response.data.errors[0].msg, {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const validationErrors = await validateForm(formData);
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      const sendData = {
        code: formData.code,
        price: formData.price,
        startDate: formData.startDate,
        endDate: formData.endDate,
      };
      axios
        .put(`/api/v1/coupons/` + formData.id, sendData)
        .then((res) => {
          toast("Cập nhật mã giám sát thành công!", {
            type: "success",
            autoClose: 1000,
          });
          handleClose(true);
        })
        .catch((err) => {
          console.log(err);
          toast("Có lỗi xảy ra!", {
            type: "error",
            autoClose: 1000,
          });
        });
    }
  };

  const validateForm = async (data) => {
    const errors = {};

    if (!data.code || data.code.trim() === "") {
      errors.code = "Mã giảm giá không được để trống.";
    }

    if (!data.price || isNaN(data.price) || Number(data.price) <= 0) {
      errors.price = "Giá tiền phải là số và lớn hơn 0.";
    }

    if (!data.startDate) {
      errors.startDate = "Ngày áp dụng không được để trống.";
    }

    if (!data.endDate) {
      errors.endDate = "Ngày hết hạn không được để trống.";
    } else if (
      data.startDate &&
      new Date(data.endDate) < new Date(data.startDate)
    ) {
      errors.endDate = "Ngày hết hạn phải sau ngày áp dụng.";
    }

    return errors;
  };

  const handleDelete = (id) => {
    swal({
      title: `Bạn muốn xóa mã giảm giá này`,
      text: ` Lưu ý: Hành động không thể khôi phục lại`,
      icon: "warning",
      buttons: ["Đóng", "Xóa"],
      successMode: true,
    }).then((ok) => {
      if (ok) {
        axios
          .delete(`/api/v1/coupons/${id}`)
          .then((res) => {
            toast("Xoá mã giảm giá thành công", {
              type: "success",
              autoClose: 1000,
            });
            getData();
          })
          .catch((err) => {
            console.log(err);
          });
      }
    });
  };

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Quản lý mã giảm giá
      </Typography>
      <Box sx={{ marginBottom: 2, display: "flex", justifyContent: "end" }}>
        <Button
          variant="contained"
          color="info"
          sx={{ width: 100 }}
          onClick={handleOpen}
        >
          Thêm
        </Button>
      </Box>
      <Paper sx={{ height: 730, width: "100%" }}>
        <DataGrid
          rows={rowsWithIndex}
          rowHeight={150}
          columns={columns}
          rowCount={totalItems}
          pagination
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) =>
            setPaginationModel(newPaginationModel)
          }
          initialState={{
            pagination: {
              paginationModel: paginationModel,
            },
          }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
          disableRowSelectionOnClick
          localeText={localeTextVietnamese}
          sx={{
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
              outline: "none",
            },
            "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
              {
                marginBottom: 0,
              },
          }}
        />
      </Paper>

      {/* Add Edit Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Paper
            sx={{
              width: 600,
              p: 5,
              height: "95vh",
              overflowY: "auto",
              overflowX: "hidden",
            }}
          >
            <Typography sx={{ pb: 5 }} variant="h4" component="h2">
              {formData.id ? "Sửa" : "Thêm"} mã giảm giá
            </Typography>
            <TextField
              label="Mã giảm giá"
              required
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              value={formData.code ?? ""}
              onChange={(e) => {
                setFormData({ ...formData, code: e.target.value });
                setErrors({ ...errors, code: "" });
              }}
              error={Boolean(errors.code)}
              helperText={errors.code}
            />
            <TextField
              label="Giá tiền"
              required
              variant="outlined"
              type="number"
              sx={{ width: "100%", paddingBottom: 5 }}
              value={formData.price ?? ""}
              onChange={(e) => {
                const value = e.target.value;
                const validValue = value.match(/^\d+(\.\d{0,2})?$/)
                  ? value
                  : formData.price;
                setFormData({ ...formData, price: validValue });
                setErrors({ ...errors, price: "" });
              }}
              error={Boolean(errors.price)}
              helperText={errors.price}
            />
            <TextField
              label="Ngày bắt đầu"
              type="date"
              required
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              InputLabelProps={{
                shrink: true,
              }}
              value={formData.startDate ?? ""}
              onChange={(e) => {
                setFormData({ ...formData, startDate: e.target.value });
                setErrors({ ...errors, startDate: "" });
              }}
              error={Boolean(errors.startDate)}
              helperText={errors.startDate}
            />
            <TextField
              label="Ngày kết thúc"
              type="date"
              required
              variant="outlined"
              sx={{ width: "100%", paddingBottom: 5 }}
              InputLabelProps={{
                shrink: true,
              }}
              value={formData.endDate ?? ""}
              onChange={(e) => {
                setFormData({ ...formData, endDate: e.target.value });
                setErrors({ ...errors, endDate: "" });
              }}
              error={Boolean(errors.endDate)}
              helperText={errors.endDate}
            />
            <Box sx={{ display: "flex", justifyContent: "end", gap: 3, pt: 2 }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleClose}
              >
                Trở về
              </Button>
              <Button
                variant="contained"
                color="info"
                onClick={formData.id ? handleUpdate : handleSubmit}
              >
                Lưu
              </Button>
            </Box>
          </Paper>
        </Box>
      </Modal>
    </Box>
  );
}
